import React from "react";
import Carrusel from "../Components/Carrusel";
import Cards from "../Components/Cards";

const MarketPrivado = () => {

  return (

    <div>
      <Carrusel></Carrusel>
      <Cards></Cards>
    </div>
  );
};

export default MarketPrivado;
